import { FormSelectNative } from "@/react/components/shared/uikit/Form/FormSelectNative";
import type { SelectOption } from "@circle-react-shared/BuilderUI/PropsMetaUnits.types";
import { Form } from "@circle-react-uikit/Form";
import { useFormItem } from "../../DefaultEditorV2/useFormItem";

export interface SelectFieldProps {
  label: string;
  name: string;
  options: SelectOption[] | ReadonlyArray<SelectOption>;
}

export const SelectField = ({ name, label, options }: SelectFieldProps) => {
  const { getFormItemProps } = useFormItem();

  return (
    <Form.Item name={name} label={label} {...getFormItemProps()}>
      {/* 
        We can't use `FormTextSelect` due to limitations in the component
        to display the options above the input field.
      */}
      <FormSelectNative name={name} options={options} />
    </Form.Item>
  );
};
